import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

const aggregateMaterial = (purchaseOrder) => {
  const totals = purchaseOrder.items
    .filter(
      (purchaseOrderItem) =>
        purchaseOrderItem.quantity &&
        purchaseOrderItem.item &&
        purchaseOrderItem.item.itemType
    )
    .reduce((totals, purchaseOrderItem) => {
      let group = totals[purchaseOrderItem.item.itemType.id] || {
        name: purchaseOrderItem.item.itemType.name,
        quantity: 0,
      };
      group.quantity += purchaseOrderItem.quantity;
      totals[purchaseOrderItem.item.itemType.id] = group;
      return totals;
    }, {});
  return Object.keys(totals).map((k) => totals[k]);
};

const Materials = ({ event, styles }) => {
  const purchaseOrder = event.purchaseOrder || event.inventoryPurchaseOrder;

  const materials = aggregateMaterial(purchaseOrder);

  if (materials.length === 0) return null;

  return (
    <FormGroup className={styles.dataValuePair}>
      <ControlLabel className={styles.dataValuePairLabel}>
        Materials
      </ControlLabel>
      <FormControl.Static
        className={styles.dataValuePairValue}
        componentClass={"div"}
      >
        {materials.map(({ name, quantity }, i) => (
          <div key={i}>
            {name}: {Math.round(quantity * 1000) / 1000}
          </div>
        ))}
      </FormControl.Static>
    </FormGroup>
  );
};

export default Materials;
